import React from "react";

type FormInputProps = {
    title: string,
    input: any,
    type?: string,
    pattern?: string
}

const FormInput = (props: FormInputProps) => {
    const { title, input, type = "text", pattern = undefined } = props;

    if (input == null) {
        throw new Error(`${title} no input`);
    }

    return (
        <div className="row col">
            <input
                type={type}
                placeholder={title}
                pattern={pattern}
                id={input.id}
                name={input.id}
                value={input.value}
                onChange={input.valueChangeHandler}
                onBlur={input.inputBlurHandler}
            />
            <label htmlFor={input.id}>
                {title}
            </label>

        </div>
    )
}

export default FormInput;
